import { breakpoints as breakpointTokens } from './tokens.generated'

// ----------------------------------------------------------------------
// One breakpoint set, shared with every other Beast surface. The console drops
// its tables to stacked list cards below `md`.
// ----------------------------------------------------------------------

const breakpoints = {
  values: { ...breakpointTokens },
}

export default breakpoints
